import { FocusableSelectors } from "./SkipLink.const";

export const isVisibleHtmlElement = (element: HTMLElement) => {
  const style = window.getComputedStyle(element);
  const isElementVisibleByCssProperty =
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    style.opacity !== "0";
  return (
    isElementVisibleByCssProperty &&
    element.offsetWidth > 0 &&
    element.offsetHeight > 0
  );
};

export const handleFocus = (
  element: React.MutableRefObject<HTMLElement | null>
) => {
  if (element.current) {
    const focusableElements = Array.from(
      element.current.querySelectorAll<HTMLElement>(
        FocusableSelectors.join(",")
      )
    );

    const firstVisibleElement = focusableElements.find(isVisibleHtmlElement);

    if (firstVisibleElement) {
      firstVisibleElement.focus();
      firstVisibleElement.scrollIntoView({
        block: "center",
      });
    } else {
      element.current.setAttribute("tabIndex", "-1");
      element.current.focus();
      element.current.scrollIntoView({
        block: "center",
      });
    }
  }
};